import { render, staticRenderFns } from "./fileManagement.vue?vue&type=template&id=23691d95&scoped=true"
import script from "./fileManagement.vue?vue&type=script&lang=js"
export * from "./fileManagement.vue?vue&type=script&lang=js"
import style0 from "./fileManagement.vue?vue&type=style&index=0&id=23691d95&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23691d95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23691d95')) {
      api.createRecord('23691d95', component.options)
    } else {
      api.reload('23691d95', component.options)
    }
    module.hot.accept("./fileManagement.vue?vue&type=template&id=23691d95&scoped=true", function () {
      api.rerender('23691d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/fileManagement.vue"
export default component.exports